import React, { useCallback } from "react";
import {
  ShoppingCartOutlined,
  CreditCardOutlined,
  BankOutlined,
  UserOutlined,
  IdcardOutlined,
  HomeOutlined
} from '@ant-design/icons';
import {useHistory} from 'react-router-dom';
import {Menu, AvatarOverlayItem} from '../styles';
import { VscLiveShare, VscDiscard  } from 'react-icons/vsc';
import { CiShoppingCart } from 'react-icons/ci';

const PageOverlayParceiro: React.FC = () => {
  const history = useHistory();
  const redirectToSaleSimulatorPage = useCallback(() => history.push('/simulador/venda'),[history]);
  const redirectToIncomeSimulatorPage = useCallback(() => history.push('/simulador/recebimento'),[history]);
  const redirectToSalesPanel = useCallback(() => history.push('/painel-de-vendas'),[history]);
  const redirectToRecivablesPanel = useCallback(() => history.push('/painel-de-recebiveis'),[history]);
  const redirectToPaymentPanel = useCallback(() => history.push('/painel-de-pagamentos'), [history] );
  const redirectToUserPage = useCallback(()=> history.push('/usuarios'), [history]);
  const redirectToBusinessPage = useCallback(() => history.push('/admin/empresas'), [history]);
  const redirectToDashboardPage = useCallback(() => history.push('/dashboard'), [history]);

  return (
    <Menu>
      <AvatarOverlayItem
        icon={<HomeOutlined />}
        onClick={redirectToDashboardPage}
      >
        Home
      </AvatarOverlayItem>

      <AvatarOverlayItem icon={<UserOutlined />} onClick={redirectToUserPage}>
        Usuários
      </AvatarOverlayItem>

      <AvatarOverlayItem
        icon={<IdcardOutlined />}
        onClick={redirectToBusinessPage}
      >
        Empresas
      </AvatarOverlayItem>

      <AvatarOverlayItem
        icon={<VscDiscard />}
        onClick={redirectToRecivablesPanel}
      >
        Painel de Recebiveis
      </AvatarOverlayItem>

      <AvatarOverlayItem
        icon={<ShoppingCartOutlined />}
        onClick={redirectToSalesPanel}
      >
        Painel de Vendas
      </AvatarOverlayItem>

      {/*<AvatarOverlayItem*/}
      {/*  icon={<CreditCardOutlined />}*/}
      {/*  onClick={redirectToIncomeSimulatorPage}*/}
      {/*>*/}
      {/*  Simulador - Recebimento*/}
      {/*</AvatarOverlayItem>*/}

      {/*<AvatarOverlayItem*/}
      {/*  icon={<CreditCardOutlined />}*/}
      {/*  onClick={redirectToSaleSimulatorPage}*/}
      {/*>*/}
      {/*  Simulador - Venda*/}
      {/*</AvatarOverlayItem>*/}

      <AvatarOverlayItem icon={<CiShoppingCart />}>
        <a href="https://www.jotform.com/app/252384120652653" target="_blank">
          Área do Parceiro
        </a>
      </AvatarOverlayItem>
    </Menu>
  );
};
export default PageOverlayParceiro;
